// components/QuotePopup/QuotePopup.jsx
import React, { useState } from "react";
import "./QuotePopup.css";
import contactService from "../../api/contactService"; // reuse same API

const QuotePopup = ({ onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    services: "",
    message: "Home page quote request"
  });

  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus({ type: "info", msg: "Sending..." });

    try {
      const payload = {
        ...formData,
        phoneNumber: formData.phoneNumber.replace(/\D/g, "")
      };

      const response = await contactService.createContact(payload);

      if (response && response.success) {
        setStatus({ type: "success", msg: "Quote request sent successfully!" });
        setFormData({ name: "", email: "", phoneNumber: "", services: "", });
      } else {
        setStatus({ type: "danger", msg: response.message || "Failed to send request." });
      }
    } catch (error) {
      console.error("Submission error:", error);
      const serverError = error.response?.data?.error || error.response?.data?.message;
      setStatus({ type: "danger", msg: serverError || "Failed to send request. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <form onSubmit={handleSubmit}>
          <h2>GET A FREE QUOTE!!</h2>
          <input 
            type="text" 
            name="name" 
            placeholder="Name *" 
            value={formData.name} 
            onChange={handleChange} 
            required 
          />
          <input 
            type="tel" 
            name="phoneNumber" 
            placeholder="Mobile Number *" 
            value={formData.phoneNumber} 
            onChange={handleChange} 
            required 
          />
          <input 
            type="email" 
            name="email" 
            placeholder="Email ID *" 
            value={formData.email} 
            onChange={handleChange} 
            required 
          />
          <input 
            type="text" 
            name="services" 
            placeholder="Service Required *" 
            value={formData.services} 
            onChange={handleChange} 
            required 
          />
          <button type="submit" disabled={loading}>
            {loading ? "Sending..." : "GET FREE QUOTE"}
          </button>
          {status.msg && (
            <p className={`status ${status.type}`}>{status.msg}</p>
          )}
        </form>


        <div className="popup-info">
          <h3>VPS INFRASTRUCTURE</h3>
          <p>HOME CONSTRUCTION EXPERTS IN <br />TAMIL NADU</p>
          <p>TURNKEY CONSTRUCTION SERVICES</p>
        </div>

        <button className="close-btn" onClick={onClose}>×</button>
      </div>
    </div>
  );
};

export default QuotePopup;
